import { useQuery } from "@tanstack/react-query";
import type { ID } from "../../data/BaseEntity";
import { getCustomerCalculationsStatistics } from "../customersApi";

export const useCustomerCalculationsStats = (customerId: ID, year: number) => {
  const { data, isLoading } = useQuery({
    queryKey: ["customers", customerId, "calculation-stats", { year }],
    queryFn: ({ signal }) => getCustomerCalculationsStatistics(customerId, year, signal),
  });
  return { calculationsStats: data, isLoading };
};
